import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import Message from 'components/atoms/Message';
import { bindActionCreators, Dispatch } from 'redux';
import { filterDelete } from 'services/filter';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { PortType, RootState } from 'types';
import { FavouritControlsInterface } from 'types/functions';
import { FilterObjectType } from 'types/search';
import { ActionsType } from 'types/system';
import { formatServerErrors } from 'utils/formatServerErrors';
import { translate } from 'utils/translate';

interface DeleteSearchModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;
    data: any;
    actions: ActionsType | undefined;

    //unused props
    highlightObject: FilterObjectType;

    //unused props
    searchObject: FilterObjectType;

    favouritControls: FavouritControlsInterface;
    port: PortType;
    setErrorHandlerAction: SetErrorHandlerAction;
}

interface DeleteSearchModelState {
    errors: object;

    //unused state
    data: any | null;

    loading: boolean;

    //unused state
    overwite: boolean;
}

class DeleteSearchModel extends Component<DeleteSearchModelProps, DeleteSearchModelState> {
    constructor(props: DeleteSearchModelProps) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            loading: false,
            overwite: false,
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.setState({ errors: {}, loading: true }, () => {
            filterDelete(this.props.port.id, this.props.data.id)
                .then(() => {
                    this.props.favouritControls.loadSavedFilters(this.props.data.id);
                    this.props.actions?.onCancel();
                })
                .catch((errors) => {
                    switch (errors.response?.status) {
                        case 422:
                            this.setState({ errors: formatServerErrors(errors), loading: false });
                            break;
                        default:
                            this.setState({ loading: false });
                            this.props.setErrorHandlerAction(errors);
                            break;
                    }

                    return;
                });
        });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Delete search')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <Message className="mt-2 cursor-pointer" type="error">
                        {translate('Once deleted, it will no longer be available to users and cannot be recovered.')}
                    </Message>

                    <div className="mt-2 flex items-center gap-1 text-md text-gray-400">
                        {translate('Are you sure you want to delete this search criteria?')}
                    </div>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                disabled={this.state.loading}
                                loading={this.state.loading}
                                type="submit"
                                className="px-4 py-2 bg-primary-delete rounded-md text-white"
                            >
                                {translate('Delete')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const deleteSearchModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
    searchObject: state.layout.searchObject,
    highlightObject: state.layout.highlightObject,
    favouritControls: state.layout.favouritControls,
});

const deleteSearchModelDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(deleteSearchModelStateToProps, deleteSearchModelDispatchToProps)(DeleteSearchModel);
